import React from 'react';
import HeadsetIcon from '@mui/icons-material/HeadsetMic';
import { twMerge } from 'tailwind-merge';

interface Props {
    loggedIn: boolean;
    children: number;
    className?: string;
}

const AgentBadge = ({ loggedIn, children, className }: Props) => {
    let iconClasses = 'text-gray-400';
    let containerClasses = 'bg-gray-200 text-gray-500';

    if (loggedIn && children > 0) {
        iconClasses = 'text-gray-800';
        containerClasses = 'bg-gray-200 text-gray-800';
    }
    if (children <= 0) {
        iconClasses = 'text-white';
        containerClasses = 'bg-red text-white';
    }

    return (
        <div
            className={twMerge(
                'flex h-6 w-11 items-center justify-center gap-2 rounded-sm px-2 py-1',
                containerClasses,
                className,
            )}
        >
            <div
                className={twMerge(
                    'flex size-4 items-center justify-center',
                    iconClasses,
                )}
            >
                <HeadsetIcon fontSize="inherit" />
            </div>
            <div className="text-xs font-bold">{children}</div>
        </div>
    );
};

export default AgentBadge;
